module.exports = __webpack_public_path__ + "img/aguas-arriba.abe4fd72.png";